import {
    STATE_INITIALIZED,
    LOGIN_SUCCESS,
    LOAD_USER_SUCCESS,
    LOGOUT_SUCCESS,
    UPDATE_PREFERENCES_SUCCESS,
} from "../Constants/userConstants.js";
//stuff we can do with the user.
const userReducer = ( state = { user: {} , isAuth: false, reload: true, loading: false }, action) => {
    switch(action.type) {
        case STATE_INITIALIZED:
            return {
                ...state,
                reload: false,
            }
        case LOGIN_SUCCESS:
        case LOAD_USER_SUCCESS:
            return {
                ...state,
                user: action.payload,
                isAuth: true,
            };
        case LOGOUT_SUCCESS:
            return {
                user: null,
                isAuth: false,
            };
        case UPDATE_PREFERENCES_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    preferences: action.payload.preferences,
                },
            };
        default:
            return state;
    }
};

export { userReducer };